export const headerStyle = {
	width: '100%',
};